export const errorStateStyles = {
	icon: 'w-8 h-8 text-[#e22446]'
} as const;
